var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useParams, useNavigate } from 'react-router-dom';
import { LinearProgress, Tabs, Tab } from '@mui/material';
import { offerList as api } from '../../../api';
import { useRequest } from '../../../hooks/requestHook';
import PageLayout from '../../atoms/PageLayout';
import OfferListPublishedCountryTable from './OfferListPublishedCountryTable';
import TransportToWarehouseTable from './TransportToWarehouseTable';
import OfferListForm from './OfferListForm';
import OffersTable from './OffersTable';
import Button from '../../atoms/BaseButton';
import OfficeDetailTable from './OfficeDetailTable';
import CreateContractsButton from '../../organisms/CreateContractsButton';
import ContractsList from './ContractsList';
import OkagesamaNoMoriContributorTable from './OkagesamaNoMoriContributorTable';
var ButtonWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 10px;\n"], ["\n  padding: 0 10px;\n"])));
var tabList = [
    'basicInformations',
    'publishedCountriesTable',
    'transportToWarehouseTable',
    'officeDetailTable',
    'offersTable',
    'contracts',
    'okagesamaNoMori',
];
var OfferListPage = function () {
    var _a = useParams().id, id = _a === void 0 ? '' : _a;
    var t = useTranslation().t;
    var _b = React.useState(true), loading = _b[0], setLoading = _b[1];
    var _c = React.useState(), offerList = _c[0], setOfferList = _c[1];
    var _d = React.useState([]), offers = _d[0], setOffers = _d[1];
    var _e = React.useState(Object.assign([], tabList)), enabledTabList = _e[0], setEnabledTabList = _e[1];
    var _f = React.useState('basicInformations'), tab = _f[0], setTab = _f[1];
    var getOfferList = useRequest(api.get);
    var navigate = useNavigate();
    var handleOfferListChange = React.useCallback(function (nextOfferList) {
        setOfferList(nextOfferList);
        setOffers(nextOfferList.offers);
    }, []);
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getOfferList({ id: id })];
                    case 1:
                        response = _a.sent();
                        if (canceled)
                            return [2 /*return*/];
                        setLoading(false);
                        if (!response)
                            return [2 /*return*/];
                        handleOfferListChange(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [id, getOfferList, setLoading, handleOfferListChange]);
    React.useEffect(function () {
        (offerList === null || offerList === void 0 ? void 0 : offerList.hasOkagesamaNoMoriContributors)
            ? setEnabledTabList(Object.assign([], tabList))
            : setEnabledTabList(tabList.filter(function (tab) { return tab !== 'okagesamaNoMori'; }));
    }, [offerList]);
    var handleChangeTab = React.useCallback(function (_event, nextTab) {
        setTab(nextTab);
    }, []);
    var producer = offerList === null || offerList === void 0 ? void 0 : offerList.producer;
    var country = t("countries.".concat(producer === null || producer === void 0 ? void 0 : producer.country.toUpperCase()));
    var name = producer ? "".concat(producer.firstname, " ").concat(producer.lastname) : '';
    var title = offerList ? t('pages.offerList.title', { country: country, name: name }) : '';
    if (loading || !offerList)
        return React.createElement(LinearProgress, null);
    return (React.createElement(PageLayout, { backLinkTo: "/admin/offer_lists", title: title, actions: React.createElement(React.Fragment, null,
            React.createElement(ButtonWrapper, null,
                React.createElement(Button, { onClick: function () {
                        return navigate("/admin/offer_lists/".concat(offerList.id, "/new_typica_stock_items"));
                    }, disabled: offerList.status !== 'expired' }, t('pages.adminCreateTypicaStockItems.title'))),
            offerList.fixed && offerList.status === 'expired' && (React.createElement(CreateContractsButton, { id: offerList.id, disabled: !offerList.contractCreatable, onChange: handleOfferListChange }))) },
        React.createElement(Tabs, { value: tab, onChange: handleChangeTab, "aria-label": "offerlist-tabs" }, enabledTabList.map(function (tb) { return (React.createElement(Tab, { key: tb, label: t("pages.offerList.".concat(tb)), value: tb, id: "form-".concat(tb), "aria-controls": "offerlist-tabs-".concat(tb) })); })),
        tab === 'basicInformations' && (React.createElement(OfferListForm, { offerList: offerList, offers: offers, onChange: handleOfferListChange })),
        tab === 'publishedCountriesTable' && (React.createElement(OfferListPublishedCountryTable, { offerList: offerList })),
        tab === 'transportToWarehouseTable' && (React.createElement(TransportToWarehouseTable, { offerList: offerList })),
        tab === 'officeDetailTable' && (React.createElement(OfficeDetailTable, { offerList: offerList })),
        tab === 'offersTable' && (React.createElement(OffersTable, { offerList: offerList, offers: offers, onChange: setOffers })),
        tab === 'contracts' && React.createElement(ContractsList, { offerList: offerList }),
        tab === 'okagesamaNoMori' && (React.createElement(OkagesamaNoMoriContributorTable, { offerList: offerList, onChange: handleOfferListChange }))));
};
export default OfferListPage;
var templateObject_1;
